export function mapWishlist(wishlists) { // eslint-disable-line
  return {
    wishlists,
    isWishlisted: wishlists.reduce((prev, curr) => ({...prev, [curr._id]: {state: true, loading: false}}), {})
  };
}
